module.exports = __webpack_public_path__ + "img/discount_bg.d56e384b.png";